import { Menu, MenuItem } from '@material-ui/core';
import Axios from 'axios';
import React, { useState } from 'react'

import Auth from '../../Modules/Auth';

export const CommentReportBtn = ({ content = '', commentId = '', loadComment }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePostReport = async (category) => {
      try {
          await Axios.post(`${BACKEND_HOST}/content-reports`, {
              content,
              parent_id: commentId,
              parentEntity: 'COMMENT',
              category,
          }, {
              headers: {
                Authorization: `bearer ${Auth.getToken()}`,
              },
          });
          loadComment()
      } catch (err) {
      }

      setAnchorEl(null);
  };

  const reportActions = [
    '욕설 및 명예 훼손',
    '홍보성',
    '음란물 및 선정성',
    '같은 내용 반복',
    '불쾌한 표현',
    '부적절한 사용자 이름',
];

  const handleOpenReport = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <a className="report_btn" aria-controls="simple-menu" aria-haspopup="true" onClick={handleOpenReport}>신고</a>
    
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {reportActions.map((action) => {
          return <MenuItem key={action} onClick={() => handlePostReport(action)}>{action}</MenuItem>
        })}
      </Menu>
    </>
  )
}


// WEBPACK FOOTER //
// ./Src/Components/Commons/CommentReportBtn.js